import { Flex } from '@mantine/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { baseWhite, inkLight } from '../../../../../styles/design-tokens';
import { Button } from '../../../../../ui-library/button/button';
import { Icon } from '../../../../../ui-library/icon/icon';
import { Text } from '../../../../../ui-library/typography/typography';
import { getTabs } from './side-section.data';
import { SideSectionTab } from './side-section.type';

type Props = {
  activeTab: SideSectionTab;
  setActiveTab: (tab: SideSectionTab) => void;
};

export const SideSectionTabs = ({ activeTab, setActiveTab }: Props) => {
  const { t } = useTranslation();
  const tabs = useMemo(() => getTabs(t), [t]);
  return (
    <Flex gap={8} role="tablist" aria-label="Side section tabs">
      {tabs.map((tab) => (
        <Button
          key={tab.id}
          radius="xl"
          size="xs"
          variant={activeTab === tab.id ? 'secondary' : 'outline'}
          role="tab"
          aria-selected={activeTab === tab.id}
          onClick={() => setActiveTab(tab.id)}
          leftSection={<Icon name={tab.icon} size={14} color={activeTab === tab.id ? baseWhite : inkLight} pointer />}
          style={{ flex: 1 }}
        >
          <Text size="small">{tab.label}</Text>
        </Button>
      ))}
    </Flex>
  );
};
